import { cn } from "@/lib/utils";

export default function PhoneIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-[19px] text-berry", className)}
      fill="none"
      viewBox="0 0 19 19"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.817 13.248C1.986 9.385 1.51 6.048 1.52 4.571c.005-.533.268-1.01.641-1.386l1.619-1.632a1.042 1.042 0 011.482 0l2.589 2.61c.409.414.409 1.083 0 1.495L6.507 7.014a.682.682 0 00-.134.782 10.957 10.957 0 004.85 4.891c.26.132.57.072.775-.135l1.345-1.356a1.042 1.042 0 011.482 0l2.572 2.594c.41.412.41 1.082 0 1.494l-1.623 1.638c-.37.373-.839.637-1.362.643-1.457.018-4.76-.45-8.595-4.317z"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeWidth="1.3"
      />
    </svg>
  );
}
